import { Theme } from "@mui/material/styles";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";
import { makeStyles } from "tss-react/mui";

export const useTermsModalStyles = makeStyles()((theme: Theme) => ({
  backdrop: {
    position: "fixed",
    inset: 0,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing.spacing8,
    background: rgba(theme.palette.black.main, 0.4),
    backdropFilter: "blur(4px)",
  },
  modalCard: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: pxToRem(360),
    maxHeight: "calc(100dvh - 48px)",
    background: theme.palette.white.main,
    borderRadius: pxToRem(24),
    boxShadow: theme.boxShadows.modal,
    overflow: "hidden",
  },
  topBar: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: `${theme.spacing.spacing8} ${theme.spacing.spacing8} ${theme.spacing.spacing4}`,
    flexShrink: 0,
  },
  closeButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing.spacing2,
    margin: 0,
    border: "none",
    background: "transparent",
    cursor: "pointer",
    color: (theme.palette.text as { main?: string }).main ?? theme.palette.text.primary,
    flexShrink: 0,
  },
  headerBlock: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    textAlign: "center",
    paddingInline: theme.spacing.spacing4,
    gap: theme.spacing.spacing4,
  },
  headerBlockContent: {
    display: "flex",
    flexDirection: "column",
    paddingInline: theme.spacing.spacing4,
  },
  headerIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing.spacing4,
    color: theme.palette.primary.main,
  },
  headerTitle: {
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightBold,
    color: (theme.palette.extraColors as { heading?: string })?.heading ?? (theme.palette.text as { main?: string }).main ?? theme.palette.text.primary,
    lineHeight: "20px",
  },
  headerDate: {
    marginTop: theme.spacing.spacing2,
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
    color: rgba((theme.palette.text as { main?: string }).main ?? theme.palette.text.primary, 0.6),
    lineHeight: "18px",
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    padding: `${theme.spacing.spacing4} ${theme.spacing.spacing8} ${theme.spacing.spacing8}`,
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "18px",
    whiteSpace: "pre-line",
    marginBottom: theme.spacing.spacing4,
  },
  footer: {
    flexShrink: 0,
    padding: `${theme.spacing.spacing8} ${theme.spacing.spacing8} ${theme.spacing.spacing8}`,
    borderTop: `1px solid ${rgba(theme.palette.black.main, 0.08)}`,
  },
  closeActionButton: {
    width: theme.width.full,
    height: theme.spacing.spacing28,
  },
}));
